import { Helmet } from '@modern-js/runtime/head';

import { useLoaderData } from '@/shared/modern-router';

import { NoSSR } from '@/shared/components/no-ssr';
import { extractTextFromHtml } from '@/shared/utils/extract-text-from-html.ssr';
import { FeatureFlagProvider } from '@crehana/feature-flags/react';
import { CandidateForm } from './candidate-form';
import { CandidateFormSkeleton } from './shared/components/candidate-form.skeleton';
import type { TPageLoaderData } from './types';

const isProd = process.env.APP_ENV === 'production';
const domain = isProd ? 'https://www.crehana.com' : 'https://qa.creha.co';

export const CandidateFormPageSSR = () => {
  const loaderData = useLoaderData() as TPageLoaderData;

  const title =
    'vacancy' in loaderData
      ? `${loaderData.vacancy.title} - ${loaderData.organization.name}`
      : '';
  const description =
    'vacancy' in loaderData
      ? extractTextFromHtml(loaderData.vacancy.description || '')
      : '';
  const _url =
    'vacancy' in loaderData ? loaderData.requestData.url.split('/p/')[1] : '';
  const url = `${domain}/p/${_url}`;
  const logo =
    'vacancy' in loaderData ? loaderData.organization.logo || '' : '';

  return (
    <>
      {'vacancy' in loaderData && (
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />

          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={logo} />
          <meta property="og:url" content={url} />

          <meta name="twitter:description" content={description} />
          <meta name="twitter:title" content={title} />
          <meta content={logo} name="twitter:image" />
        </Helmet>
      )}

      <NoSSR fallback={<CandidateFormSkeleton />}>
        <FeatureFlagProvider
          organizationId={
            'vacancy' in loaderData
              ? Number(loaderData.vacancy.centralized_organization_id)
              : 0
          }
        >
          <CandidateForm loaderData={loaderData} />
        </FeatureFlagProvider>
      </NoSSR>
    </>
  );
};
